import CampaignTrackingParameterService from "./CampaignTrackingParameterService";
export default CampaignTrackingParameterService;